import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='northwestern-mutual-investing-services-llc'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography component='h1'>
          Northwestern Mutual Investment <WidowBlock>Services, LLC</WidowBlock>
        </Typography>
        <Typography>
          Northwestern Mutual Investment Services, LLC (NMIS) has been a member of the Northwestern Mutual family of companies since
          1968. NMIS serves the investment planning and product needs of individuals and businesses and is committed to offering
          high&#45;quality products, personal service and innovative solutions.
        </Typography>
        <Typography>
          Our client services go above and beyond what you may expect from a financial services provider. We believe in working with
          you and for you to accomplish your goals and meet your needs.
        </Typography>
        <Typography>
          Special account services for individuals with NMIS accounts include electronic transfers, dividend reinvestment, a mutual
          fund purchase program, account protection, direct deposit, check writing privileges and&#160;
          <Link
            id="nm-investing-services-online-account-link"
            variant='primaryDeemphasize'
            linkUrl="https://nmis.netxinvestor.com/"
            isOutgoingLink>
            online account access
          </Link>.
        </Typography>
        <Typography>
          We offer a broad array of individual investment services ranging from college education funding to IRA solutions.
        </Typography>
        <Typography>
          Our reputation is built on the solid foundation of Northwestern Mutual. We are a wholly owned company offering investment
          services in over 60 cities nationwide. Client investable assets currently total more than &#36;29 billion.
        </Typography>
        <Typography component='h2'>
          For Corporations
        </Typography>
        <Typography>
          Choosing a retirement plan for your business, whether you are a sole proprietor or CEO, is a decision that can profoundly
          impact your long&#45;term financial well&#45;being and that of your employees.
        </Typography>
        <Typography component='h3'>
          Business Retirement Plan Services
        </Typography>
        <Typography>
          Objective guidance and a wide variety of choices are imperative when selecting a provider for your business retirement plan.
        </Typography>
        <Typography component='h3'>
          For Individuals
        </Typography>
        <Typography>
          Northwestern Mutual Investment Services, LLC (NMIS) serves the investment services and product needs of individuals.
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: (<>Provide high&#45;quality investment services and products.</>) },
            { bulletText: 'Build diversified investment portfolios.' },
            { bulletText: 'Develop objective, personalized plans.' },
            { bulletText: (<>Focus on long&#45;term investment results.</>) },
          ]} />
        <Typography>
          We offer financial accounts that can help you consolidate your assets, while providing valuable features and distribution
          choices for assets in your retirement when changing jobs.
        </Typography>
        <Typography>
          NMIS Online provides detailed account information, investing tools, and market research through our online services for
          individuals.
        </Typography>
        <Typography component='h3'>
          Online Services for Individuals
        </Typography>
        <Typography>
          <Link
            id="nm-investing-services-nmis-online-link"
            variant='primaryDeemphasize'
            linkUrl="https://nmis.netxinvestor.com/"
            isOutgoingLink>
            NMIS Online
          </Link>
          &#160;provides detailed account information, investing tools, and market research.
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: ('Easily view balances and account activity.') },
            { bulletText: 'Establish and adjust account preferences, including enrollment in electronic delivery of statements, confirmations and prospectus and proxy materials for participating issuers.' },
            { bulletText: (<>Monitor your investments&#39; performance, such as the change in value from the prior day and previous year&#45;end.</>) },
            { bulletText: 'Access market summaries and commentaries to stay apprised of how your accounts are doing, as well as industry trends.' },
            { bulletText: 'View statements, confirmations and tax documents online.' },
          ]} />
        <Typography component='h3'>
          Account Access
        </Typography>
        <Typography>
          Access your account(s) and the many other features of NMIS Online, at&#160;
          <Link
            id="nm-investing-services-nmis-login-link"
            variant='primaryDeemphasize'
            linkUrl="https://nmis.netxinvestor.com/"
            isOutgoingLink>
            NMIS Account Login
          </Link>
          .
        </Typography>
        <Typography>
          If you do not have a NMIS Online User ID,&#160;
          <Link
            id="nm-investing-services-enroll-link"
            variant='primaryDeemphasize'
            linkUrl="https://nmis.netxinvestor.com/"
            isOutgoingLink>
            enroll now
          </Link>
          . Once you receive your user ID and password, do not share it with anyone. If you have forgotten your user ID or password,
          please call our help desk at 1&#45;866&#45;664&#45;7737, option 3, (7:30 AM &#45; 5:00 PM CST).
        </Typography>
        <Typography component='h3'>
          Download Account information
        </Typography>
        <Typography>
          Simplify your finances by downloading your NMIS account information into your financial management software.
        </Typography>
        <Typography>
          This powerful tool will help you:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: ('Manage your finances, quickly and easily.') },
            { bulletText: (<>Eliminate time&#45;consuming manual entry of investment information.</>) },
            { bulletText: 'Get a complete snapshot of all your NMIS investments and finances in one place.' },
          ]} />
      </Col>
    </Row>
  </SectionContainer>
);
